export default __webpack_public_path__ + "static/bg-81a3e4d2a87890c13067dafacac4582e.jpg";